import splitBreakpoints from '../split-breakpoints'

function parseMargin ({
  top = { value: 0, unit: 'px' },
  right = { value: 0, unit: 'px' },
  bottom = { value: 0, unit: 'px' },
  left = { value: 0, unit: 'px' }
}) {
  return {
    margin: `
      ${top.value}${top.unit}
      ${right.value}${right.unit}
      ${bottom.value}${bottom.unit}
      ${left.value}${left.unit}
    `
  } 
}

export default splitBreakpoints(parseMargin)
